import React from 'react'
import {
    Redirect
} from 'react-router-dom'
import {
  connect,
} from 'react-redux';
import { setAlertDanger, clearAlerts } from '../store/WriteClass';


class AdminDeniedComponent extends React.Component {

  componentDidMount() {
    const { setAlertDanger, clearAlerts } = this.props
    setAlertDanger({
        message: 'You do not have permission to view the admin area!',
        timeout: 3000,
        onDismiss: () => { clearAlerts() }
    })
  }

  render() {
    return ( <Redirect to={{ pathname: '/adminlogin' }}/> )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
    return {
        setAlertDanger: (alert) => dispatch(setAlertDanger(alert)),
        clearAlerts: () => dispatch(clearAlerts()),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminDeniedComponent)


// WEBPACK FOOTER //
// ./src/components/AdminDeniedComponent.js